module.exports = __webpack_public_path__ + "detail4.fb66a442.png";